<template>
  <vxe-modal ref="modal" v-model="formVisible" title="修改密码" width="90%" @show="showModal">
    <ResetPwd @closeParent="closeParent" />
  </vxe-modal>
</template>
<script>
import ResetPwd from '../common/resetPwd.vue'

export default {
  components: {
    ResetPwd
  },
  data() {
    return {
      formVisible: false
    }
  },
  methods: {
    showModal() {},
    // 关闭父窗口
    closeParent() {
      this.formVisible = false
    }
  }
}
</script>
<style lang="less" scoped></style>
